import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Icon from "../icon-v2"
import linkHandler from "../../helpers/storyblokLinkHandler"

const Social = ({ blok }) => (
  <SbEditable content={blok}>
    <a
      title={blok.title}
      href={linkHandler(blok.link)}
      className="social grid__col"
      target={blok.target || "_self"}
    >
      {blok.icon &&
        Icon &&
        React.createElement(Icon, {
          className: "footer__icon",
          icon: `fa-${blok.icon.toLowerCase()}`,
          iconType: "fab",
          size: "16",
          color: "white"
        })}
    </a>
  </SbEditable>
)

Social.defaultProps = {
  icon: "",
}

Social.propTypes = {
  blok: PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.shape({
      linktype: PropTypes.string,
      cached_url: PropTypes.string,
      url: PropTypes.string,
    }),
    target: PropTypes.string,
  }).isRequired,
}

export default Social
